/**
 * FooterSection - 푸터 섹션
 *
 * 회사 정보 및 서비스 링크
 * - 좌측: 회사 정보 (브랜드명, 사업자정보)
 * - 우측: 서비스 링크 (이용약관, 개인정보처리방침, 문의하기)
 * - 하단: 저작권 및 슬로건
 */

import React from 'react';
import { Typography, Divider } from 'antd';

const { Text, Link } = Typography;

export const FooterSection: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        background: '#1a1a2e',
        padding: '48px 24px 32px',
        color: '#fff',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* 상단: 회사 정보 + 링크 */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            gap: '40px',
          }}
        >
          {/* 좌측: 회사 정보 */}
          <div style={{ flex: 1, minWidth: '280px' }}>
            {/* 브랜드명 */}
            <Text
              strong
              style={{
                color: '#fff',
                fontSize: '20px',
                display: 'block',
                marginBottom: '20px',
              }}
            >
              채점톡
            </Text>

            {/* 회사 정보 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '13px',
                lineHeight: '1.6',
              }}
            >
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                매쓰브레인부스트원격학원
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                대표자: 최원혁
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                주소: 경기도 고양시 일산동구 고봉로 20-26 716호
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                사업자등록번호: 230-93-01882
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                통신판매번호: 2023-고양일산동-3026
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                전화: 031-905-2971
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                이메일: dashiki78@gmail.com
              </Text>
              <Text style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '13px' }}>
                개인정보보호책임자: 최원혁
              </Text>
            </div>
          </div>

          {/* 우측: 링크 */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              alignItems: 'flex-end',
            }}
          >
            <Link
              href="#"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '14px',
              }}
            >
              이용약관
            </Link>
            <Link
              href="#"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '14px',
              }}
            >
              개인정보처리방침
            </Link>
            <Link
              href="mailto:dashiki78@gmail.com"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '14px',
              }}
            >
              문의하기
            </Link>
          </div>
        </div>

        <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.1)', margin: '32px 0 24px' }} />

        {/* 하단: 저작권 및 슬로건 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Text
            style={{
              color: 'rgba(255, 255, 255, 0.5)',
              fontSize: '13px',
            }}
          >
            © {currentYear} 매쓰브레인부스트원격학원. All rights reserved.
          </Text>
          <Text
            style={{
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '13px',
            }}
          >
            채점의 시작은 채점톡
          </Text>
        </div>
      </div>
    </footer>
  );
};
